const config = {
    apiUrl: "https://api.chabhiwala.com/admin/",
    // apiUrl: "https://dev-node-api.kmdkeys.com/admin/",
    // apiUrl: "https://p9rf4sf9-7500.inc1.devtunnels.ms/admin/",
    // apiUrl: "http://localhost:7500/admin/",
    // apiUrl: "http://192.168.29.117:7500/admin/",
}

export default config;
